<!-- <div [ngClass]="{ 'disabled': disableReasonBlock }">-->
<div>
  <div class="reasons-block" *ngIf="!hidePcnAllFields">
    <div class="reasons-autocomplete">
      <h2>
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 37 38">
          <g id="Group_211" data-name="Group 210" transform="translate(-246 -132)">
            <circle id="Ellipse_10" data-name="Ellipse 8" cx="18.5" cy="18.5" r="18.5" transform="translate(246 132)"
              fill="#ABCB0B" />
            <text id="_2" data-name="1" transform="translate(256 162)" fill="#FFF" font-size="30" font-family="Outfit"
              font-weight="700">
              <tspan x="0" y="0">{{ isNexusEnabled ? '3' : '2' }}</tspan>
            </text>
          </g>
        </svg>
        select reason(s)
      </h2>
    </div>

    <div class="search-reasons-bar">
      <svg fill="#c5c5c5" style="padding-right: 14px" width="30px" height="30px" viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg" class="search-icon">
        <path fill-rule="evenodd"
          d="M11,2 C15.9705627,2 20,6.02943725 20,11 C20,13.124779 19.2636898,15.0775836 18.0323074,16.6171757 L21.7071068,20.2928932 C22.0976311,20.6834175 22.0976311,21.3165825 21.7071068,21.7071068 C21.3466228,22.0675907 20.7793918,22.0953203 20.3871006,21.7902954 L20.2928932,21.7071068 L16.6171757,18.0323074 C15.0775836,19.2636898 13.124779,20 11,20 C6.02943725,20 2,15.9705627 2,11 C2,6.02943725 6.02943725,2 11,2 Z M11,4 C7.13400675,4 4,7.13400675 4,11 C4,14.8659932 7.13400675,18 11,18 C14.8659932,18 18,14.8659932 18,11 C18,7.13400675 14.8659932,4 11,4 Z" />
      </svg>
      <form #select2Form="ngForm" class="select2-form">
        <select2 #reasonSearcher [data]="reasonSearchData" [value]="value" multiple="true"
          (update)="onSelectReasons($event)" (search)="onReasonsSearch($event)" hideSelectedItems="true"
          class="app-select app-select2" name="reasons-select" id="inputReasons" [(ngModel)]="selectedReasons"
          placeholder="Search for reasons..." customSearchEnabled>
        </select2>
        <button type="submit" style="display: none"></button>
      </form>
      <svg class="search-icon" style="padding-left: 14px" width="30px" height="30px" viewBox="0 -2.5 24 24"
        id="meteor-icon-kit__regular-shopping-basket" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M16.5538 4.99996L13.7786 2.10916C13.3962 1.71075 13.4091 1.07771 13.8075 0.69524C14.2059 0.31277 14.8389 0.32568 15.2214 0.7241L19.2214 4.89076C19.2547 4.92549 19.2851 4.96199 19.3124 4.99996H21.8196C21.9297 4.99996 22.0397 5.00906 22.1484 5.02717C23.2379 5.20876 23.9739 6.23922 23.7923 7.32876L22.2649 16.4932C22.0239 17.9397 20.7723 19 19.3058 19H4.69427C3.22776 19 1.97619 17.9397 1.73509 16.4932L0.207693 7.32876C0.189583 7.2201 0.180481 7.11012 0.180481 6.99996C0.180481 5.89539 1.07591 4.99996 2.18048 4.99996H4.68763C4.71497 4.96199 4.7453 4.92549 4.77863 4.89076L8.77863 0.7241C9.16111 0.32568 9.79414 0.31277 10.1926 0.69524C10.591 1.07771 10.6039 1.71075 10.2214 2.10916L7.44624 4.99996H16.5538zM2.18048 6.99996L3.70788 16.1644C3.78825 16.6465 4.20544 17 4.69427 17H19.3058C19.7946 17 20.2118 16.6465 20.2922 16.1644L21.8196 6.99996H2.18048zM12 9C12.5523 9 13 9.4477 13 10V14C13 14.5522 12.5523 15 12 15C11.4477 15 11 14.5522 11 14V10C11 9.4477 11.4477 9 12 9zM7.00002 9C7.55231 9 8.00002 9.4477 8.00002 10V14C8.00002 14.5522 7.55231 15 7.00002 15C6.44774 15 6.00002 14.5522 6.00002 14V10C6.00002 9.4477 6.44774 9 7.00002 9zM17 9C17.5523 9 18 9.4477 18 10V14C18 14.5522 17.5523 15 17 15C16.4477 15 16 14.5522 16 14V10C16 9.4477 16.4477 9 17 9z"
          fill="#c5c5c5" />
      </svg>

    </div>

    <div class="reasons-categories" *ngIf="!isCustomLettersVisible && !isCustomParagraphsVisible">
      <div class="browse-reasons" [ngClass]="{ active: selectedReasonsCategory === 'browse' }"
        (click)="selectedReasonsCategory = 'browse'">
        <span class="reason-title">
          <span class="strong">all</span> reasons
        </span>
      </div>

      <div class="recent-reasons" [ngClass]="{ active: selectedReasonsCategory === 'recent' }"
        (click)="selectedReasonsCategory = 'recent'">
        <span class="reason-title">
          <span class="strong">recent</span> reasons
        </span>
      </div>

      <div class="top-reasons" [ngClass]="{ active: selectedReasonsCategory === 'top' }"
        (click)="selectedReasonsCategory = 'top'">
        <span class="reason-title">
          <span class="strong">top</span> reasons
        </span>
      </div>

      <!-- <div class="search-reasons" [ngClass]="{ 'active': selectedReasonsCategory === 'search' }"
        (click)="selectedReasonsCategory = 'search'">
        <span class="reason-title">
          <span class="strong">search</span> reasons
        </span>
      </div> -->
    </div>

    <div class="reasons-container" *ngIf="!isCustomLettersVisible && !isCustomParagraphsVisible">
      <div class="browse-container" *ngIf="selectedReasonsCategory === 'browse'">
        <div class="categories">
          <div class="category" *ngFor="let reasonCat of reasonsObject" [ngClass]="{
              active: reasonCat.active,
              'active-click': reasonCat.id === browseCatActiveClickId
            }" [attr.data-id]="'reason-' + reasonCat.id" (mouseenter)="selectBrowseReasonCategory($event, reasonCat)"
            (click)="
              selectBrowseReasonCategory($event, reasonCat);
              setActiveClickBrowseCat(reasonCat.id)
            ">
            <span>{{ reasonCat.caption }}</span>
          </div>
        </div>
        <div class="reasons">
          <!-- <div class="question-arrow"
              (click)="scrollToQuestions()">
            <span class="question-arrow-text">scroll to questions</span> <br/>
            <span class="arrow-down">&#8595;</span>
          </div> -->
          <div class="subcategories" *ngFor="let reasonSubCat of browseReasonsSelectedCategory">
            <span [ngClass]="[
                propertyExists(reasonSubCat.subcategories)
                  ? 'subcat'
                  : 'browse-reason',
                isReasonSubCatSelected(reasonSubCat) ? 'selected' : ''
              ]" (click)="addReason(reasonSubCat)" [attr.data-id]="'reason-' + reasonSubCat.id">
              <h4 *ngIf="propertyExists(reasonSubCat.subcategories)">
                {{ reasonSubCat.caption }}
              </h4>
              <h4 *ngIf="
                  !propertyExists(reasonSubCat.subcategories) &&
                  reasonSubCat.tooltip.length > 0
                " [ngbPopover]="reasonSubCat.tooltip" triggers="hover" appDynamicPopover>
                {{ reasonSubCat.caption }}
              </h4>
              <h4 *ngIf="
                  !propertyExists(reasonSubCat.subcategories) &&
                  reasonSubCat.tooltip.length === 0
                ">
                {{ reasonSubCat.caption }}
              </h4>
            </span>
            <span *ngFor="let reasonSubCat2 of reasonSubCat.subcategories">
              <span class="browse-reason level2" [ngClass]="{
                  disabled: propertyExists(reasonSubCat2.subcategories),
                  selected:
                    isReasonSelected(reasonSubCat2) ||
                    (!reasonSubCat2.isPermitted &&
                      !propertyExists(reasonSubCat2.subcategories))
                }" (click)="addReason(reasonSubCat2)" [attr.data-id]="'reason-' + reasonSubCat2.id">
                <h4 *ngIf="propertyExists(reasonSubCat2.subcategories)">
                  {{ reasonSubCat2.caption }}
                </h4>
                <h4 *ngIf="!propertyExists(reasonSubCat2.subcategories)" [ngbPopover]="reasonSubCat2.tooltip"
                  triggers="hover" appDynamicPopover>
                  {{ reasonSubCat2.caption }}
                </h4>
              </span>
              <span *ngFor="let reason of reasonSubCat2.subcategories">
                <span class="browse-reason level3" [ngClass]="{
                    selected: isReasonSelected(reason) || !reason.isPermitted
                  }" (click)="addReason(reason)" [attr.data-id]="'reason-' + reason.id">
                  <h4 [ngbPopover]="reason.tooltip" triggers="hover" appDynamicPopover>
                    {{ reason.caption }}
                  </h4>
                </span>
              </span>
            </span>
          </div>
        </div>
      </div>

      <div class="recent-container" *ngIf="selectedReasonsCategory === 'recent'">
        <div class="reason" *ngFor="let reason of recentReasons" (click)="addReason(reason)"
          [attr.data-id]="'recent-reason-' + reason.id" [ngbPopover]="reason.tooltip" triggers="hover"
          appDynamicPopover>
          {{ reason.text }}
          <span class="plus"></span>
        </div>
      </div>

      <div class="top-container" *ngIf="selectedReasonsCategory === 'top'">
        <div class="reason" *ngFor="let reason of topReasons" (click)="addReason(reason)"
          [attr.data-id]="'top-reason-' + reason.id" [ngbPopover]="reason.tooltip" triggers="hover" appDynamicPopover>
          {{ reason.text }}
          <span class="plus"></span>
        </div>
      </div>
    </div>
  </div>
</div>